module.exports = "li {\n  padding: 10px;\n  margin: 0px; }\n\nul {\n  list-style: none; }\n\n.wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row wrap;\n          flex-flow: row wrap; }\n\n.product-name {\n  font-weight: bold;\n  font-size: 1.1em; }\n\n.product-image {\n  float: left;\n  max-height: 100px;\n  max-width: 100px;\n  min-width: 100px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/type-ahead/type-ahead.component.sass
// module id = ./src/app/type-ahead/type-ahead.component.sass
// module chunks = main